import { DateTimeStr } from '../types';

export interface User {
  readonly id: string;
  readonly role: UserRole;
  readonly email: string;
  readonly name: string;
  readonly surname: string;
  readonly avatar?: string;
  readonly language?: string;
  readonly groupId: Group['id'] | null;
  readonly loginMethod?: LoginMethod;
  readonly lastLogin?: DateTimeStr;
}

export interface Group {
  readonly id: string;
  readonly name: string;
  readonly users?: readonly User[];
}

export enum UserRole {
  CLIENT_USER = 'CLIENT_USER',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  SUPERADMIN = 'SUPERADMIN',
}

export const allowedClientUserRoles = [UserRole.CLIENT_USER, UserRole.CLIENT_ADMIN];

export enum LoginMethod {
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
}
